var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUserDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 30 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-11{fill:#232323;}.cls-22{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2-2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M31.5,22.5a9,9,0,1,0-15.08,6.63h0l.29.24.06.05.48.37.16.11c.18.12.36.24.54.34l.12.07a5.2,5.2,0,0,0,.62.32l0,0a9.06,9.06,0,0,0,2.18.68H21a5.93,5.93,0,0,0,.72.1h.09c.24,0,.48,0,.73,0s.49,0,.73,0h.09c.24,0,.48-.05.71-.09h.06a9.29,9.29,0,0,0,2.15-.68l.07,0,.6-.31.14-.08a5.69,5.69,0,0,0,.52-.33l.18-.12.42-.33.09-.07.3-.25h0A9,9,0,0,0,31.5,22.5Zm-17.35,0A8.35,8.35,0,1,1,28,28.74a1.75,1.75,0,0,0-.29-.18L25,27.18a.73.73,0,0,1-.4-.65v-1l.2-.27a6.66,6.66,0,0,0,.86-1.68,1.18,1.18,0,0,0,.68-1.07V21.38A1.23,1.23,0,0,0,26,20.6V19.07a2.58,2.58,0,0,0-.62-1.91,3.67,3.67,0,0,0-2.9-1,3.71,3.71,0,0,0-2.9,1A2.61,2.61,0,0,0,19,19.07V20.6a1.23,1.23,0,0,0-.29.78v1.16a1.18,1.18,0,0,0,.44.92,6.3,6.3,0,0,0,1,2.09v.95a.72.72,0,0,1-.38.64l-2.59,1.41-.24.16A8.35,8.35,0,0,1,14.15,22.5ZM27.4,29.25l-.35.24-.17.11-.47.27-.11.05a7.68,7.68,0,0,1-1.14.49h0a6.32,6.32,0,0,1-.62.18h0c-.22,0-.43.1-.65.13h0l-.62.07h-.11a6.08,6.08,0,0,1-.61,0c-.21,0-.41,0-.62,0h-.11l-.62-.07h0a8,8,0,0,1-1.28-.32h0l-.61-.23h0l-.56-.26-.07,0c-.17-.09-.33-.19-.49-.29l-.14-.09c-.15-.09-.3-.2-.44-.3l0,0h0l2.59-1.42a1.38,1.38,0,0,0,.72-1.21V25.32l-.08-.09a5.5,5.5,0,0,1-1-2l0-.13L19.6,23a.53.53,0,0,1-.25-.45V21.38a.5.5,0,0,1,.18-.4l.11-.1V19a2,2,0,0,1,.46-1.42,3.07,3.07,0,0,1,2.41-.82,3.06,3.06,0,0,1,2.4.81A2,2,0,0,1,25.37,19v1.87l.11.1a.5.5,0,0,1,.18.4v1.16a.53.53,0,0,1-.38.51l-.17.05-.05.16a6.18,6.18,0,0,1-.81,1.65,3,3,0,0,1-.25.31l-.08.09v1.22a1.37,1.37,0,0,0,.77,1.23l2.77,1.39.05,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    width: 45,
    height: 45
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserDark);
export default __webpack_public_path__ + "static/media/icon_user_dark.3994ee8ab42905744a8ea4fce65995d7.svg";
export { ForwardRef as ReactComponent };